import React from 'react';
import { sendChatComposerEnvisionLead } from '../../../../redux/leadModalActions.js';
import GenericLeadSyncComposer from '../GenericLeadSyncComposer.js';
const EnvisionAddLeadComposer = () => {
  return <GenericLeadSyncComposer id={'envision'} title={'Envision'} syncMethod={sendChatComposerEnvisionLead} />;
};

export default EnvisionAddLeadComposer;
